/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type BasketSummaryResponseSimType =
  (typeof BasketSummaryResponseSimType)[keyof typeof BasketSummaryResponseSimType];

export const BasketSummaryResponseSimType = {
  TRIPLESIM: "TRIPLESIM",
  ESIM: "ESIM",
} as const;
